import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Notification } from '../notification-list-element/notification-list-element.component';
import { ImportExportApiService } from 'src/app/data-transfer/services/import-export-api-service';
import { TranslocoService } from '@jsverse/transloco';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';

@Component({
  selector: 'app-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrl: './notification-menu.component.scss'
})
export class NotificationMenuComponent implements OnDestroy {
  notifications : Notification[] = [];

  private unseenSentCount = 0;
  private unseenSentSubscription: Subscription;
  private unseenReceivedCount = 0;
  private unseenReceivedSubscription: Subscription;

  constructor(private importExportApiService: ImportExportApiService,
              private dataExchangeRequestApiService: DataExchangeRequestApiService,
              private translateService: TranslocoService) {
    this.unseenSentSubscription = this.dataExchangeRequestApiService.unseenSentDataExchangeRequests$.subscribe(count => {
      this.unseenSentCount = count;
      this.createNotifications();
    });
    this.unseenReceivedSubscription = this.dataExchangeRequestApiService.unseenReceivedDataExchangeRequests$.subscribe(count => {
      this.unseenReceivedCount = count;
      this.createNotifications();
    });
    this.createNotifications();
  }

  createNotifications() : void {
    this.notifications = [];
    this.createImportSystemsNotification();
    this.createImportUnitNotification();
    this.createImportComponentNotification();
    this.createImportMaterialNotification();
    this.createTrackingSystemsNotification();
    this.createTrackingUnitNotification();
    this.createTrackingComponentNotification();
    this.createTrackingMaterialNotification();
    this.createSentDataExchangeRequestNotification();
    this.createReceivedDataExchangeRequestNotification();
  }

  createImportSystemsNotification() : void {
    if(this.importExportApiService.newSystemCandidateCount > 0) {
      let message =  "";
      if( this.importExportApiService.newSystemCandidateCount === 1) {
        message = this.translateService.translate('notifications.import.PackagingSystemSingle');
      } else {
        message = this.translateService.translate('notifications.import.PackagingSystem', { count: this.importExportApiService.newSystemCandidateCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/packaging-system/import/new","","input"));
    }
  }

  createImportUnitNotification() : void {
    if(this.importExportApiService.newUnitCandidateCount > 0) {
      let message =  "";
      if( this.importExportApiService.newUnitCandidateCount === 1) {
        message = this.translateService.translate('notifications.import.PackagingUnitSingle');
      } else {
        message = this.translateService.translate('notifications.import.PackagingUnit', { count: this.importExportApiService.newUnitCandidateCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/packaging-unit/import/new","","input"));
    }
  }

  createImportComponentNotification() : void {
    if(this.importExportApiService.newComponentCandidateCount > 0) {
      let message =  "";
      if( this.importExportApiService.newComponentCandidateCount === 1) {
        message = this.translateService.translate('notifications.import.PackagingComponentSingle');
      } else {
        message = this.translateService.translate('notifications.import.PackagingComponent', { count: this.importExportApiService.newComponentCandidateCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/component/import/new","","input"));
    }
  }

  createImportMaterialNotification() : void {
    if(this.importExportApiService.newMaterialCandidateCount > 0) {
      let message =  "";
      if( this.importExportApiService.newMaterialCandidateCount === 1) {
        message = this.translateService.translate('notifications.import.PackagingMaterialSingle');
      } else {
        message = this.translateService.translate('notifications.import.PackagingMaterial', { count: this.importExportApiService.newMaterialCandidateCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/material/import/new","","input"));
    }
  }
  createTrackingSystemsNotification() : void {
    if(this.importExportApiService.newSystemTrackingCount > 0) {
      let message =  "";
      if( this.importExportApiService.newSystemTrackingCount === 1) {
        message = this.translateService.translate('notifications.tracking.PackagingSystemSingle');
      } else {
        message = this.translateService.translate('notifications.tracking.PackagingSystem', { count: this.importExportApiService.newSystemTrackingCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/packaging-system/change-tracking/new","","track_changes"));
    }
  }

  createTrackingUnitNotification() : void {
    if(this.importExportApiService.newUnitTrackingCount > 0) {
      let message =  "";
      if( this.importExportApiService.newUnitTrackingCount === 1) {
        message = this.translateService.translate('notifications.tracking.PackagingUnitSingle');
      } else {
        message = this.translateService.translate('notifications.tracking.PackagingUnit', { count: this.importExportApiService.newUnitTrackingCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/packaging-unit/change-tracking/new","","track_changes"));
    }
  }

  createTrackingComponentNotification() : void {
    if(this.importExportApiService.newComponentTrackingCount > 0) {
      let message =  "";
      if( this.importExportApiService.newComponentTrackingCount === 1) {
        message = this.translateService.translate('notifications.tracking.PackagingComponentSingle');
      } else {
        message = this.translateService.translate('notifications.tracking.PackagingComponent', { count: this.importExportApiService.newComponentTrackingCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/component/change-tracking/new","","track_changes"));
    }
  }

  createTrackingMaterialNotification() : void {
    if(this.importExportApiService.newMaterialTrackingCount > 0) {
      let message =  "";
      if( this.importExportApiService.newMaterialTrackingCount === 1) {
        message = this.translateService.translate('notifications.tracking.PackagingMaterialSingle');
      } else {
        message = this.translateService.translate('notifications.tracking.PackagingMaterial', { count: this.importExportApiService.newMaterialTrackingCount });
      }
      this.notifications.push(new Notification(message,"/cockpit/data-management/packaging-import/material/change-tracking/new","","track_changes"));
    }
  }

  createSentDataExchangeRequestNotification() : void {
    if (this.unseenSentCount > 0) {
      const message = this.unseenSentCount === 1
        ? this.translateService.translate('notifications.dataExchange.SentSingle')
        : this.translateService.translate('notifications.dataExchange.Sent', { count: this.unseenSentCount });
      this.notifications.push(new Notification(
        message,
        '/' + PathResolveService.getDataExchangeRequestsPath(true),
        '',
        'swap_horiz'
      ));
    }
  }

  createReceivedDataExchangeRequestNotification() : void {
    if (this.unseenReceivedCount > 0) {
      const message = this.unseenReceivedCount === 1
        ? this.translateService.translate('notifications.dataExchange.ReceivedSingle')
        : this.translateService.translate('notifications.dataExchange.Received', { count: this.unseenReceivedCount });
      this.notifications.push(new Notification(
        message,
        '/' + PathResolveService.getDataExchangeRequestsPath(true) + '?tab=1',
        '',
        'swap_horiz'
      ));
    }
  }

  ngOnDestroy(): void {
    this.unseenSentSubscription?.unsubscribe();
    this.unseenReceivedSubscription?.unsubscribe();
  }
}
